export const userConstants = {
    ADD_USER: 'ADD_USER',
    DELETE_USER: 'DELETE_USER',
};
